import React from 'react';

const ComingSoonBanner = ({ title, description, estimatedDate }) => {
  return (
    <div className="bg-gradient-to-r from-orange-400 via-yellow-400 to-orange-500 text-white rounded-xl p-6 mb-6 shadow-lg">
      <div className="flex items-center gap-3 mb-3">
        <span className="text-3xl">🚧</span>
        <h3 className="text-xl font-bold">{title}</h3>
      </div>
      <p className="text-sm opacity-90 mb-3">
        {description}
      </p>
      {estimatedDate && (
        <div className="flex items-center gap-2 text-sm">
          <span className="text-xl">📅</span>
          <span className="font-semibold">Disponibilidad estimada: {estimatedDate}</span>
        </div>
      )}
      <div className="mt-4 p-3 bg-white/20 rounded-lg">
        <p className="text-sm font-medium mb-1">🎯 Mientras tanto:</p>
        <p className="text-xs opacity-90">
          Explora nuestros módulos operacionales como Generación de Texto, Imágenes y Chat con IA.
        </p>
      </div>
    </div>
  );
};

export default ComingSoonBanner;